<template>
	<div class="template tree">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span class="require">*</span></label>
			<div class="input_value" @click="dialogVisible=true"> {{dataVal.Value}} <span class="icon-right"></span> </div>
		</div>

		<el-dialog title="请选择部门" custom-class="dialog-choose-dept" :visible.sync="dialogVisible" width="92%" top="10vh" :close-on-click-modal="false">
			<div style="padding: 10px 20px;">
				<el-input
				  placeholder="输入关键字进行过滤"
				  v-model="filterText">
				</el-input>
			</div>
			
			
			<el-tree class="input_value" style="width: 100%;"
			:highlight-current="true" accordion 
			ref="tree"
			:data="treeData" 
			:props="defaultProps" 
			@node-click="handleNodeClick"
			:filter-node-method="filterNode">
			</el-tree>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	// import TreeData from '../assets/js/data';
	import {GetAssetsDeparts} from '../api/ccas.js'
	export default {
		props: ['dataVal'],
		data() {
			return {
				treeData: [],
				dialogVisible:false,
				defaultProps: {
					children: 'children',
					label: 'text'
				},
				filterText:''
			}
		},
		mounted() {
			GetAssetsDeparts().then(res =>{
				this.treeData = JSON.parse(res.Body).data;
			});
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		methods: {
			handleNodeClick(data) {
				this.dataVal.Value=data.text;
				this.dataVal.Values=[[data.id,data.text]];
				this.$emit('child-event', this.dataVal, data);
			},
			//对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示，返回 false 则表示这个节点会被隐藏
			filterNode(value, data) {
				if (!value) return true;
				return data.text.indexOf(value) !== -1;
			}
		}
	}
</script>

<style>
	@import '../assets/css/common.css';
	.dialog-choose-dept .el-dialog__body{
		max-height: calc(80vh - 125px);
		overflow: scroll;
		padding: 15px 5px;
	}
	.dialog-choose-dept .el-dialog__body::-webkit-scrollbar{
		display: none;
	}
	.input_value{
		height: auto;
	}
</style>
